import React from 'react';
import { useParams } from 'react-router-dom';
import { PackageTracking } from '../components/PackageTracking/PackageTracking';

const PackageTrackingScreen: React.FC = () => {
  // Get id from URL parameters
  const params = useParams();
  console.log('PackageTrackingScreen: All params =', params);
  
  // Extract the id parameter from the URL
  const { id } = useParams<{ id?: string }>();
  console.log('PackageTrackingScreen: id =', id);

  return (
    <div className="container">
      <PackageTracking transactionId={id} />
    </div>
  );
};

export default PackageTrackingScreen;
